import type { Metadata } from "next";
import { SiteFooter, SiteNav } from "@/components/site-chrome";

export const metadata: Metadata = { title: "Terms of Service — EasyShot" };

const SECTIONS: { h: string; p: string }[] = [
  {
    h: "1. The service",
    p: "EasyShot generates short-form marketing videos from product information you provide, using third-party AI models for script writing and avatar rendering. Output quality varies with input quality; we do not guarantee any specific advertising performance.",
  },
  {
    h: "2. Cash balance and billing",
    p: "Services are charged in USD against your EasyShot cash balance. The displayed price is confirmed before a paid action. Charges are placed when a render is queued and automatically returned to the same cash balance if the render fails. Promotional welcome balance is non-transferable and not withdrawable.",
  },
  {
    h: "3. Your content",
    p: "You must own or have the rights to any product information, images and text you submit. You retain ownership of generated videos and may use them commercially. You may not use EasyShot to create content that is illegal, deceptive, or infringes third-party rights — including impersonating real people without consent.",
  },
  {
    h: "4. AI-generated content",
    p: "Videos feature AI-generated presenters and voices. You are responsible for complying with the disclosure rules of the platforms where you publish (e.g. TikTok and Meta synthetic-media policies) and with advertising law in your market.",
  },
  {
    h: "5. Acceptable use",
    p: "No scraping pages you have no right to access, no medical/financial claims that are false or unsubstantiated, no content targeting minors with restricted products, and no attempts to reverse-engineer the service.",
  },
  {
    h: "6. Liability",
    p: "The service is provided \"as is\". To the maximum extent permitted by law, our total liability is limited to the amount you paid in the 3 months before the claim.",
  },
  {
    h: "7. Changes",
    p: "We may update these terms; material changes will be announced on this page with a new effective date. Continued use after changes means acceptance.",
  },
];

export default function TermsPage() {
  return (
    <>
      <SiteNav />
      <main className="mx-auto w-full max-w-3xl px-5 py-16">
        <h1 className="text-3xl font-semibold tracking-tight">
          Terms of Service
        </h1>
        <p className="mt-2 text-sm text-muted">Effective date: August 15, 2026</p>
        <div className="mt-10 space-y-8">
          {SECTIONS.map((s) => (
            <section key={s.h}>
              <h2 className="text-lg font-semibold">{s.h}</h2>
              <p className="mt-2 text-sm leading-7 text-muted">{s.p}</p>
            </section>
          ))}
        </div>
      </main>
      <SiteFooter />
    </>
  );
}
